import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MobileAdhesion from '@wix/da-ads/pkg/adunits/anon/MobileAdhesion';
import UserMobileAdhesion from '@wix/da-ads/pkg/adunits/user/MobileAdhesion';
import DesktopAdhesion from '@wix/da-ads/pkg/adunits/anon/DesktopAdhesion';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { useSelector } from 'react-redux';
import {
  getCurrentAdSafety,
  getSafetyState,
} from '@wix/da-shared-react/pkg/Ads/redux/selectors';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import AnonOrUserUnit from '@wix/da-ads/pkg/adunits/AnonOrUserUnit';

const AdhesionAd: React.FC<{}> = () => {
  const isMobile = useContext(MobileContext);
  const { adsEnabled } = useContext(SessionContext);
  const adsType = useAdsType();
  const location = useLocation();
  const adSafety = useSelector(state => getCurrentAdSafety(state));
  const adSafetyState = useSelector(state => getSafetyState(state));
  const isLoggedUpAds = useFlag('ads_loggedin_up');

  if (
    !location.pathname.match(/\/(gallery|favourites)/) ||
    (adsType !== 'anon' && !isLoggedUpAds)
  ) {
    return null;
  }

  if (isMobile && adsEnabled) {
    return (
      <ErrorBoundary debugComponent="MobileAdhesion">
        <AnonOrUserUnit
          anon={MobileAdhesion}
          user={UserMobileAdhesion}
          safety={adSafety!}
          safetyState={adSafetyState}
        />
      </ErrorBoundary>
    );
  }

  if (adsEnabled && adsType === 'anon') {
    return (
      <ErrorBoundary debugComponent="DesktopAdhesion">
        <DesktopAdhesion safety={adSafety!} safetyState={adSafetyState} />
      </ErrorBoundary>
    );
  }

  return null;
};
AdhesionAd.displayName = 'AdhesionAd';

export default AdhesionAd;
